module.exports = __webpack_public_path__ + "img/qrcode_for_gh_a6c2f551a025_860.cb926a76.jpg";